import { render, staticRenderFns } from "./FormatList.vue?vue&type=template&id=e72ce7ca&scoped=true&"
import script from "./FormatList.vue?vue&type=script&lang=js&"
export * from "./FormatList.vue?vue&type=script&lang=js&"
import style0 from "./FormatList.vue?vue&type=style&index=0&id=e72ce7ca&scoped=true&lang=css&"
import style1 from "./FormatList.vue?vue&type=style&index=1&id=e72ce7ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72ce7ca",
  null
  
)

export default component.exports